
import * as _ref_Li9qcy9kYXRlLmpz_ from './js/date.js';
import * as _ref_Li9qcy9maXJlYmFzZS1idW5kbGVkLTEyLjMuMC5qcw_ from './js/firebase-bundled-12.3.0.js';
import * as _ref_Li9qcy91dGlsLmpz_ from './js/util.js';
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import { instantiate } from './composeApp.uninstantiated.mjs';


const exports = (await instantiate({
    './js/date.js': _ref_Li9qcy9kYXRlLmpz_,
    './js/firebase-bundled-12.3.0.js': _ref_Li9qcy9maXJlYmFzZS1idW5kbGVkLTEyLjMuMC5qcw_,
    './js/util.js': _ref_Li9qcy91dGlsLmpz_,
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_
})).exports;

export const {
memory,
_initialize
} = exports


